export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-455x256.1140515c.png";